export enum CheckboxSize {
  tiny = "tiny",
  medium = "medium",
  big = "big",
}
export default null
